import ContactInfo from "./ContactInfo";

import ContactModal from "./ContactModal";

import { useState } from "react";
import { useI18n } from "../../i18n/I18nContext";

function Contact() {
  const { t, translations } = useI18n();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalHeading, setModalHeading] = useState(t("contact.modalProcessing"));
  return (
    <>
      <section className="contact-section" id="kontakt">
        {showModal ? (
          <ContactModal
            setShowModal={setShowModal}
            modalHeading={modalHeading}
            modalText={modalText}
          ></ContactModal>
        ) : (
          ""
        )}
        <h1 id="contact-header">{t("contact.heading")}</h1>

        <div className="contact-content">
          <div className="left-info-container">
            <h3 className="contact-heading"></h3>

            {/* Informacije o restoranu */}
            <div className="info-wrapper">
              {/* Pojedinacna informacija */}

              <ContactInfo
                key={1}
                imgPath={"/images/clock.webp"}
                Title={t("contact.workingHours")}
                text={translations.contact.hours}
              ></ContactInfo>
              <ContactInfo
                key={2}
                imgPath={"/images/adresa.webp"}
                Title={t("contact.address")}
                text={translations.contact.addresses}
              ></ContactInfo>
              <ContactInfo
                key={3}
                imgPath={"/images/telephone.webp"}
                Title={t("contact.phone")}
                text={translations.contact.phones}
              ></ContactInfo>
              <ContactInfo
                key={4}
                imgPath={"/images/rucak.webp"}
                Title={t("contact.dineIn")}
                text={[]}
              >
                <p>{t("contact.dineInAvailable")}</p>
                <div className="dine-in-locations">
                  <span>📍 {translations.contact.addresses[0]}</span>
                  <span>📍 {translations.contact.addresses[1]}</span>
                </div>
              </ContactInfo>
              <ContactInfo
                key={5}
                imgPath={"/images/shipped.webp"}
                Title={t("contact.delivery")}
                text={[]}
              >
                <div className="contact-delivery-links">
                  <a
                    href="https://wolt.com/sr/srb/belgrade/restaurant/two-guys-smash-burgers"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img src="/images/wolt.png" alt={t("alt.wolt")} />
                  </a>
                  <a
                    href="https://glovoapp.com/rs/sr/beograd/two-guys-smash-burger-beg/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img src="/images/glovo.webp" alt={t("alt.glovo")} />
                  </a>
                  <a
                    href="https://misterd.rs/place/two-guys-smash-burgers-dostava"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img src="/images/mrd.webp" alt={t("alt.misterD")} />
                  </a>
                </div>
              </ContactInfo>
            </div>
          </div>

          {/* Kontakt forma desno */}
          <div className="right-contact-form-container">
            <h3 className="contact-heading">{t("contact.writeUs")}</h3>

            <form action="">
              <div className="form-row">
                <label htmlFor="imeprez">{t("contact.fullName")}</label>
                <input type="text" id="imeprez" />
              </div>
              <div className="form-row">
                <label htmlFor="email">{t("contact.email")}</label>
                <input type="text" id="email" />
              </div>
              <div className="form-row">
                <label htmlFor="naslov">{t("contact.subject")}</label>
                <input type="text" id="naslov" />
              </div>
              <div className="form-row">
                <label htmlFor="poruka">{t("contact.message")}</label>
                <textarea name="Text1" id="poruka" />
              </div>
              <button
                type="submit"
                onClick={async (e) => {
                  e.preventDefault();
                  setShowModal(true);
                  setModalText("");
                  setModalHeading(t("contact.modalProcessing"));

                  try {
                    const webUrl =
                      "https://two-guys-burger-back.vercel.app/questions";
                    const localUrl = "http://localhost:5000/questions";
                    const res = await fetch(webUrl, {
                      method: "POST",
                      body: JSON.stringify({
                        title: "Naslov",
                        fullName: "Milan",
                        email: "miki@gmail",
                        message: "dadad",
                      }),
                      headers: {
                        "Content-Type": "application/json",
                      },
                    });

                    const data = await res.json();

                    console.log(data);
                    if (res.status.toString().startsWith("4")) {
                      throw new Error(
                        t("contact.badRequest"),
                      );
                    }
                    if (res.status.toString().startsWith("5")) {
                      throw new Error(
                        t("contact.serverError"),
                      );
                    }

                    setModalText(
                      t("contact.modalSuccessText"),
                    );
                    setModalHeading(t("contact.modalSuccessHeading"));
                    console.log(data);
                  } catch (e) {
                    setModalHeading(t("contact.modalFailureHeading"));
                    setModalText(t("contact.modalFailureText"));
                  }
                }}
                className="submit-message-btn btn-classic"
              >
                {t("contact.submit")}
              </button>
            </form>
          </div>
        </div>

        <div className="map-container">
          <h3 className="contact-heading" id="map-heading">
            {t("contact.mapPrefix")} <strong>Two Guys</strong>{" "}
            {t("contact.mapSuffix")}
          </h3>
          <div className="locations" style={{ gap: "2rem", display: "flex" }}>
            {" "}
            <div className="location" style={{ width: "50%" }}>
              <h3 className="contact-heading adress-heading">
                {t("contact.locationPozeska")}
              </h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2119.5774391432337!2d20.41184144685176!3d44.775315815109536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a6fd2d696bc23%3A0x20fa194282e74548!2z0J_QvtC20LXRiNC60LAgODMsINCR0LXQvtCz0YDQsNC0IDExMDAw!5e0!3m2!1ssr!2srs!4v1778325732196!5m2!1ssr!2srs"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`${t("alt.map")} - ${t("contact.locationPozeska")}`}
              ></iframe>
            </div>
            <div className="location" style={{ width: "50%" }}>
              <h3 className="contact-heading adress-heading">
                {t("contact.locationNatalije")}
              </h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2830.379942073819!2d20.457961299999997!3d44.813823799999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a7aad991290b3%3A0x82fbbb4854fc0aa6!2zS9GA0LDRmdC40YbQtSDQndCw0YLQsNC70LjRmNC1IDEsINCR0LXQvtCz0YDQsNC0IDExMDAw!5e0!3m2!1ssr!2srs!4v1759649582245!5m2!1ssr!2srs"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                title={`${t("alt.map")} - ${t("contact.locationNatalije")}`}
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
